$(document).ready(function() {
  $("section.cart").hide();

  $("li.cart").click(function() {
    if ($("section.cart .container:visible").length !== 0) {
      $("section.cart").slideUp();
    } else {
      $("section.cart").slideDown();
    }
  });

  $("li.search").click(function() {
    if ($("section.search .container:visible").length !== 0) {
      $("section.search").slideUp();
    } else {
      $("section.search").slideDown();
    }
  });

  $("#slides").slides({
    // TODO: Move this image to the local host
    preloadImage: 'http://slidesjs.com/examples/images-with-captions/img/loading.gif',
    play: 5000,
    paginationClass: 'balls',
    currentClass: 'selected'
  });

  $("li img[data-thumbnail-for]").click(function() {
    $("li img.current").removeClass("current");
    $("img#main_image").attr('src', $(this).attr('data-thumbnail-for'));
    $(this).addClass("current");
    $(this).addClass("hover");
  });


});
